/*
 * @Description:
 * @LastEditors: wjx
 * @Date: 2020-11-10 13:57:25
 */

import mainAccountPart from './part/mainAccount';
import subAccountPart from './part/subAccount';
import operationLogPart from './part/operationLog';

export const mainAccount = [
  {
    name: '主账号管理',
    childMenu: [mainAccountPart]
  }
];
export const subAccount = [
  {
    name: '子账号管理',
    childMenu: [subAccountPart]
  }
];

export const operationLog = [
  {
    name: '子账号管理',
    childMenu: operationLogPart
  }
];
